import type { IconProps } from './../../models/icon';

export function PaintIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M10.5183 20.6062C7.91609 23.2253 3.49404 24.0927 0.942871 21.4736C4.34444 17.953 0.942871 16.2522 3.49404 13.701C3.94202 13.202 4.48702 12.7996 5.09576 12.5183C5.70452 12.2371 6.36423 12.0829 7.03457 12.0653C7.70492 12.0477 8.37182 12.1669 8.99451 12.4157C9.61723 12.6646 10.1827 13.0377 10.6562 13.5125C11.1298 13.9872 11.5016 14.5536 11.7489 15.1769C11.9962 15.8002 12.1138 16.4674 12.0946 17.1377C12.0753 17.808 11.9195 18.4673 11.6368 19.0753C11.3541 19.6834 10.9503 20.2275 10.4503 20.6743L10.5183 20.6062Z"
        />
        <path
          fill={secondaryColor}
          d="M20.9107 1.17745C21.3437 1.34711 21.7372 1.60375 22.0672 1.93149C22.397 2.26333 22.6548 2.65967 22.8245 3.09572C22.9942 3.53175 23.0722 3.99812 23.0535 4.46565C23.0386 4.92717 22.93 5.38081 22.734 5.79896C22.5381 6.21709 22.2592 6.59096 21.9141 6.89778L11.954 15.8165C11.9005 15.5994 11.8322 15.3857 11.7494 15.1769C11.5021 14.5536 11.1303 13.9873 10.6567 13.5125C10.1831 13.0378 9.6177 12.6646 8.995 12.4158C8.69749 12.2969 8.38989 12.2076 8.07666 12.1487L17.1008 2.08456C17.4096 1.73744 17.7862 1.45725 18.2074 1.26127C18.6286 1.06528 19.0855 0.957661 19.5499 0.945037C20.0146 0.928681 20.4778 1.00778 20.9107 1.17745Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M20.9107 1.17745C21.3437 1.34711 21.7372 1.60375 22.0672 1.93149C22.397 2.26333 22.6548 2.65967 22.8245 3.09572C22.9942 3.53175 23.0722 3.99812 23.0535 4.46565C23.0386 4.92717 22.93 5.38081 22.734 5.79896C22.5381 6.21709 22.2592 6.59096 21.9141 6.89778L11.954 15.8165C11.9005 15.5994 11.8322 15.3857 11.7494 15.1769C11.5021 14.5536 11.1303 13.9873 10.6567 13.5125C10.1831 13.0378 9.6177 12.6646 8.995 12.4158C8.69749 12.2969 8.38989 12.2076 8.07666 12.1487L17.1008 2.08456C17.4096 1.73744 17.7862 1.45725 18.2074 1.26127C18.6286 1.06528 19.0855 0.957661 19.5499 0.945037C20.0146 0.928681 20.4778 1.00778 20.9107 1.17745Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M10.5183 20.6062C7.91609 23.2253 3.49404 24.0927 0.942871 21.4736C4.34444 17.953 0.942871 16.2522 3.49404 13.701C3.94202 13.202 4.48702 12.7996 5.09576 12.5183C5.70452 12.2371 6.36423 12.0829 7.03457 12.0653C7.70492 12.0477 8.37182 12.1669 8.99451 12.4157C9.61723 12.6646 10.1827 13.0377 10.6562 13.5125C11.1298 13.9872 11.5016 14.5536 11.7489 15.1769C11.9962 15.8002 12.1138 16.4674 12.0946 17.1377C12.0753 17.808 11.9195 18.4673 11.6368 19.0753C11.3541 19.6834 10.9503 20.2275 10.4503 20.6743L10.5183 20.6062Z"
        />
      </g>
    </svg>
  );
}
